"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoginForm;

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _firebase = require("../firebase");

var _auth = require("firebase/auth");

var _LoginSignup = require("./LoginSignup");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function LoginForm(props) {
  var setAction = props.setAction;

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      infoMessage = _useState4[0],
      setInfoMessage = _useState4[1];

  var emailRef = (0, _react.useRef)();
  var pwdRef = (0, _react.useRef)();

  function setErrorToDisplay(e) {
    var msg = e.message || e; // Change some error messages

    if (e.code === 'auth/wrong-password') {
      msg = 'Invalid Password.';
    }

    if (e.code === 'auth/user-not-found') {
      // Original message: "There is no user record corresponding to this identifier. The user may have been deleted."
      msg = 'There is no user registered with that email address.';
    }

    console.log(e);
    setErrorMessage(msg);
  }

  function signIn(_x) {
    return _signIn.apply(this, arguments);
  }

  function _signIn() {
    _signIn = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var email, password, exists;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              email = emailRef.current.value;
              password = pwdRef.current.value; // validate input

              if ((0, _LoginSignup.validEmail)(email)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", setErrorMessage("Please enter a valid email."));

            case 7:
              if (!(password.length === 0)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", setErrorMessage("Please enter a password."));

            case 9:
              _context.next = 11;
              return (0, _LoginSignup.accountExists)(email);

            case 11:
              exists = _context.sent;

              if (exists) {
                console.log('signing in...');
                (0, _auth.signInWithEmailAndPassword)(_firebase.auth, email, password).then(props.onSubmit).catch(function (e) {
                  setErrorToDisplay(e);
                });
              } else {
                setErrorMessage('There is no user registered with that email address.');
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _signIn.apply(this, arguments);
  }

  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: signIn,
    style: {
      width: "80%",
      maxWidth: "20rem",
      margin: "1rem auto"
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "email",
    className: "form-control mb-2",
    name: "email",
    ref: emailRef,
    placeholder: "Email"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "password",
    className: "form-control mb-2",
    name: "password",
    ref: pwdRef,
    placeholder: "Password"
  }), /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: "btn btn-round btn-primary m-1 w-100",
    id: "submitAuth"
  }, "Sign In"), /*#__PURE__*/_react.default.createElement("div", {
    id: "error-message",
    className: "text-danger py-2"
  }, errorMessage), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-center forgot-pass",
    onClick: function onClick() {
      return setAction('forgot');
    }
  }, "Forgot your password?"), /*#__PURE__*/_react.default.createElement("div", {
    id: "info-message",
    className: "p-1 text"
  }, infoMessage));
}